import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getRetakeSchedule = params => {
  return api.get("/admin/retake-schedule", {
    params,
  });
};

export const getRetakeScheduleQueryOptions = params => {
  return queryOptions({
    queryKey: ["retakeSchedule", params],
    queryFn: () => getRetakeSchedule(params),
  });
};

export const useRetakeSchedule = ({ queryConfig, ...params }) => {
  return useQuery({
    ...getRetakeScheduleQueryOptions(params),
    ...queryConfig,
  });
};
